export default __webpack_public_path__ + "media/images/main-adv/tv-133b927a55a4d915b1f4b57f0bbfc642.png";